import { useDialog } from '@ariessolutionsio/primitives-richproducts';
import { SignInDialog, SignInDialogProps } from '../../../components/common/dialogs/sign-in.dialog';

export function useSignInDialog(props: SignInDialogProps) {
  return useDialog(<SignInDialog {...props} />);
}
